import { U } from '../../../../assets/img/svg/details';

interface PalestraInterface {
    palestra: any
}

const ContentSection: React.FC<PalestraInterface> = ({palestra}: PalestraInterface) => {
    return (
        <section className='pt-4 pb-12 md:-mt-8 text-[#575757]'>
            {palestra && (
                <div className="max-w-screen-lg mx-auto px-4">
                    <div className="pt-4 md:pt-0 flex flex-col md:flex-row gap-x-8 gap-y-4 items-center">
                        <div className="group relative">
                            <U className='w-[220px] md:w-[270px] h-[220px] md:h-[270px] mx-auto'/>
                            <img src={palestra.palestrante?.foto} alt={palestra.palestrante?.nome} className='absolute bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 w-[180px] md:w-[220px] h-[180px] md:h-[220px] rounded-full object-cover transition-all duration-200 group-hover:scale-105' />
                        </div>

                        <div className="bg-white p-8 md:p-14 shadow-custom rounded-xl">
                            <h3 className="font-semibold text-xl">
                                Palestrante: {palestra.palestrante?.nome}
                            </h3>

                            <p className='text-sm'>
                                <strong>Palestra: {palestra.horario}</strong> - {palestra.title}
                            </p>
                        </div>
                    </div>

                    <div className="mt-10">
                        <h3 className="text-lg md:text-xl font-semibold">
                            Palestra:
                        </h3>

                        <div className='text-sm 2xl:text-base text-justify' dangerouslySetInnerHTML={{ __html: palestra.content }}></div>
                    </div>

                    <div className="mt-10">
                        <h3 className="text-lg md:text-xl font-semibold">
                        {palestra.palestrante?.nome}:
                        </h3>

                        <div className='text-sm 2xl:text-base text-justify' dangerouslySetInnerHTML={{ __html: palestra.palestrante?.content }}></div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default ContentSection;